export const DATE_TIME_FORMAT = "dd MMM yyyy, hh:mm:ss a";
export const DATE_FORMAT = "dd MMM yyyy";
// Compact date/time: 2-digit year, minute precision (no seconds).
export const DATE_TIME_SHORT_FORMAT = "dd MMM yy, hh:mm a";
// Weekday-prefixed date, no time (e.g. "Tuesday, 7 Jul 2026").
export const DATE_WEEKDAY_FORMAT = "EEEE, d MMM yyyy";
